import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import { AsYouType } from 'libphonenumber-js';

import * as api from '../../../../api';

import { Button } from '../../../../components/Button';
import { getPrevisitAsset } from '../../../../utils';
import { getProviderNameFull } from '../../../../utils/provider';
import { TIME_OF_DAY_FORMAT } from '../../../../utils/dateTime';
import { constructAddressSchedulingConfirmation } from '../../../../utils/practice';

import defaultStyles from '../../../../styles/formSetStyles.module.css';
import styles from '../index.module.css';

interface Props {
  timeSlotConfirmation: api.EhrTimeSlot.EhrTimeSlot &
    api.EhrTimeSlot.TimeSlotConfirmation;
  navigateToNextPage: () => Promise<void>;
}

const ConfirmationPage: React.FC<Props> = ({
  timeSlotConfirmation,
  navigateToNextPage,
}) => {
  const { t } = useTranslation();
  const {
    providerFirstName,
    providerLastName,
    providerPrefix,
    providerSuffix,
    timezone,
    startTime,
    address,
    city,
    state,
    zipCode,
    phoneNumber,
    previsitImageUrl,
  } = timeSlotConfirmation;
  const providerImageSrc = getPrevisitAsset(previsitImageUrl || '');
  return (
    <div>
      <div className={defaultStyles.Label}>
        {t('Your appointment is confirmed.')}
      </div>
      <div className={styles.CardContainer}>
        <div
          className={styles.ProviderCard}
          style={{ backgroundImage: `url(${providerImageSrc})` }}
        />
        <div>
          <div className={styles.ProviderName}>
            {getProviderNameFull({
              provider: {
                firstName: providerFirstName,
                lastName: providerLastName,
                prefix: providerPrefix,
                suffix: providerSuffix,
              },
            })}
          </div>
          <div
            className={styles.InfoBlock}
            data-test-id="confirmation-time-slot"
          >
            {moment(startTime).tz(timezone).format('MMM Do')} at{' '}
            {moment(startTime).tz(timezone).format(TIME_OF_DAY_FORMAT)}
          </div>
          <div className={styles.InfoBlock}>
            {constructAddressSchedulingConfirmation({
              address,
              city,
              state,
              zip: zipCode,
            })}
          </div>
          <div>
            <a
              href={`tel:${phoneNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.PhoneLink}
            >
              {new AsYouType('US').input(phoneNumber)}
            </a>
          </div>
        </div>
      </div>
      <div className={styles.ButtonSubmitWrapper}>
        <Button
          type="button"
          children={t('Continue')}
          onClick={navigateToNextPage}
        />
      </div>
    </div>
  );
};

export default ConfirmationPage;
